import AirportsService from "@/core/services/airports.service";
import ApiService from "@/core/services/api.service";
import APIEndpointsService from "@/core/services/api-endpoints.service";
import ContactsService from "@/core/services/contacts.service";
import ServiceRegistry from "@/core/services/service-registry";
import SubscribersService from "@/core/services/subscribers.service";
import TripsService from "@/core/services/trips.service";

const apiService = new ApiService();
const apiEndpointsService = new APIEndpointsService();

ServiceRegistry.register(ApiService, apiService);
ServiceRegistry.register(AirportsService, new AirportsService(apiService, apiEndpointsService));
ServiceRegistry.register(ContactsService, new ContactsService(apiService, apiEndpointsService));
ServiceRegistry.register(SubscribersService, new SubscribersService(apiService, apiEndpointsService));
ServiceRegistry.register(TripsService, new TripsService(apiService, apiEndpointsService));
